<template>
  <section class="hero glow-bg">
    <div class="hero-content">
      <h1 class="title">
        用代码构建<br />
        <span class="gradient-text">未来的数字体验</span>
      </h1>
      <p class="subtitle">
        我们是专注于高端定制开发的技术工作室，提供从 UI/UX 设计到全栈开发的一站式解决方案，为您的业务赋能。
      </p>
      <div class="action-buttons">
        <a href="#portfolio" class="btn btn-primary">查看案例</a>
        <a href="#services" class="btn btn-secondary">了解服务</a>
      </div>
    </div>
    
    <div class="hero-image-placeholder">
      <div class="abstract-shape shape-1"></div>
      <div class="abstract-shape shape-2"></div>
      <div class="glass-card">
        <div class="code-line"></div>
        <div class="code-line short"></div>
        <div class="code-line medium"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection'
}
</script>

<style lang="scss" scoped>
.hero {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 100px 20px 60px;
  max-width: 1200px;
  margin: 0 auto;
  gap: 60px;
}

.hero-content {
  flex: 1;
  max-width: 600px;
  z-index: 2;
}

.title {
  font-size: 56px;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 24px;
  color: var(--text-primary);

  .gradient-text {
    background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}

.subtitle {
  font-size: 18px;
  line-height: 1.6;
  color: var(--text-secondary);
  margin-bottom: 40px;
}

.action-buttons {
  display: flex;
  gap: 20px;
}

.btn-secondary {
  background: var(--surface-color);
  color: var(--text-primary);
  box-shadow: var(--shadow-sm);
  border: 1px solid rgba(0,0,0,0.05);

  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-md);
    color: var(--primary-color);
  }
}

.hero-image-placeholder {
  flex: 1;
  position: relative;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.abstract-shape {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  z-index: 0;
  animation: float 6s ease-in-out infinite;
}

.shape-1 {
  width: 300px;
  height: 300px;
  background: rgba(79, 70, 229, 0.3);
  top: 10%;
  right: 10%;
}

.shape-2 {
  width: 250px;
  height: 250px;
  background: rgba(124, 58, 237, 0.3);
  bottom: 10%;
  left: 10%;
  animation-delay: 2s;
}

.glass-card {
  width: 340px;
  height: 220px;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-md);
  z-index: 1;
  padding: 30px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  justify-content: center;
  animation: float 4s ease-in-out infinite reverse;
}

.code-line {
  height: 12px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  width: 100%;

  &.short {
    width: 60%;
  }

  &.medium {
    width: 80%;
  }
}

@keyframes float {
  0% { transform: translateY(0); }
  50% { transform: translateY(-20px); }
  100% { transform: translateY(0); }
}

@media (max-width: 992px) {
  .hero {
    flex-direction: column;
    text-align: center;
    padding-top: 120px;
  }
  
  .hero-content {
    align-items: center;
    display: flex;
    flex-direction: column;
  }

  .title {
    font-size: 42px;
  }
}
</style>
